<template>
    <div class="uploadAttachment">
        <div class="title_result" v-if="isShowTitle">
            <span >文件图片</span>
        </div>
        <div class="title" v-else>
            <span>上传附件</span>
            <span class="content">选择您要上传的照片</span>
        </div>
        <div class="uploadBox">
            <van-uploader
                :after-read="onRead"
                multiple
                accept="image/*"
                preview-image
                v-model="postData"
                preview-full-image
                preview-size="72px"
                :before-delete="handleDelete"
                class="uploadCenter"
            />
        </div>
    </div>
</template>
<script>
    import api from '../service/modules/complaintApis'
    const HTTPS = 'https://'
    export default {
        props: { 
            imgUrl: Array,
            isShowTitle: {
                type: Boolean,
                default: () => {
                    return false;
                },
            },
        },
        data () {
            return {
                postData: [], // 待上传的文件
                cos: '', // cos实例
                cosArg: '', // cos上传参数
                tempFile: [],
                uploadTemp: [] // 上传成功后的文件
            };
        },
        created () {
            this.getSession()
        },
        watch: {
            imgUrl: {
                immediate: true,
                handler (newValue, oldValue) {
                    this.postData.splice(0, this.postData.length);
                    this.uploadTemp.splice(0, this.uploadTemp.length);
                    if (Array.isArray(newValue) && newValue.length > 0) {
                        for (let i = 0; i < newValue.length; i++) {
                            this.postData.push({ url: newValue[i], isImage: true });
                            this.uploadTemp.push(newValue[i]);
                        }
                    }
                },
                deep: true
            }
        },
        methods: {
            // 获取图片后上传图片到图片服务器
            onRead (file) {
                this.tempFile = []
                if (Array.isArray(file)) {
                    // 多图
                    for (let index = 0; index < file.length; index++) {
                        // this.postData.push(file[index])
                        this.tempFile.push(file[index])
                    }
                } else {
                    // 单图
                    // this.postData.push(file)
                    this.tempFile.push(file)
                }
                this.handleuploadTemp()
            },
            // 执行上传操作
            handleuploadTemp () {
                this.$Toast.loading({
                    duration: 0,
                    message: '文件上传中...',
                    forbidClick: true
                });
                let cosKey = ''
                for (let i = 0; i < this.tempFile.length; i++) {
                    cosKey = `${this.cosArg.keyPrefix}/${new Date().getTime()}/${this.tempFile[i].file.name}`
                    console.log('this.tempFile[i].file:', this.tempFile[i].file);
                    this.cos.putObject({
                        Bucket: this.cosArg.bucket,
                        Region: this.cosArg.region,
                        Key: cosKey,
                        Body: this.tempFile[i].file,
                        onHashProgress: function (progressData) {
                            console.log('校验中', JSON.stringify(progressData));
                        },
                        onProgress: function (progressData) {
                            console.log('上传中', JSON.stringify(progressData));
                        }
                    }, (err, res) => {
                        if (!err) {
                            this.uploadTemp.push(HTTPS + res.Location)
                            this.$dispatch('fileUploadData', JSON.parse(JSON.stringify(this.uploadTemp)));
                            setTimeout(()=>{
                                this.$Toast.clear();
                            }, 3000)
                        }
                    })
                }
            },
            // 获取上传cos所需的凭证
            getSession () {
                api.common.getCosSession({}).then(res => {
                    if (res.ret === 0) {
                        this.cosArg = res.data
                        this.cos = new COS({
                            getAuthorization: function (options, callback) {
                                callback({
                                    TmpSecretId: res.data.credentials && res.data.credentials.tmpSecretId,
                                    TmpSecretKey: res.data.credentials && res.data.credentials.tmpSecretKey,
                                    XCosSecurityToken: res.data.credentials && res.data.credentials.sessionToken,
                                    ExpiredTime: res.data.expiredTime
                                });
                            }
                        })
                    }
                });
            },
            // 删除预览文件
            handleDelete (files, details) {
                if (files instanceof Object) {
                    if (files.hasOwnProperty('file')) {
                        // 删除源文件
                        this.postData = this.postData.filter(item => {
                            return item['file'] == undefined;
                        });
                    } else if (files.hasOwnProperty('url')) {
                        // 删除上传成功后预览文件
                        this.postData.splice(details.index, 1);
                        this.uploadTemp.splice(details.index, 1);
                    }
                    let imgFiles = [...this.uploadTemp];
                    this.$dispatch('fileUploadData', imgFiles);
                    return true;
                }
            }
        },
        destroyed () {
            this.$Toast.clear();
        }
    };
</script>

<style lang="less" scoped>
.uploadAttachment {
    width: 100%;
    .title {
        font-size: 14px;
        .content {
            font-size: 12px;
            color: #aaa;
        }
        height: 60px;
    }
    .title_result {
        font-size: 14px;
        color: #666;
        .content {
            font-size: 12px;
            color: #aaa;
        }
        height: 60px;
    }
    .uploadBox {
        margin-bottom: -20px;
    }

}
</style>
